import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/navbar/NavBar"

const AdminHome = () => {

  return (
	<>
	  <Navbar type="9495" />
	  <Typography variant="h5" sx={{ m: 10 }}>
		Home
	  </Typography>
	  <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
		<Button sx={{m: 1, width: "25%"}} variant="outlined" onClick={() => window.location.href="../tables"}>
		  CRUD e tabelle
		</Button>
		<Button sx={{m: 1, width: "25%"}} variant="outlined" onClick={() => window.location.href="../profilo"}>
		  Profilo utente
		</Button>
	  </Box>
	</>
  );
};

export default AdminHome;

	